import { render, staticRenderFns } from "./StickyHeader.vue?vue&type=template&id=edbe6b76&"
import script from "./StickyHeader.vue?vue&type=script&lang=js&"
export * from "./StickyHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports